$(function() {
    $('.js-filter-view-trigger').on('click', function(event) {
        event.preventDefault();

        $('input[name="filter[view]"]').val($(this).data('value')).change();
    });

    Event.on('Listing.changeView', function() {
        let activeView = $('input[name="filter[view]"]').val(),
            isRow = activeView == 'row';

        $('.js-filter-view-trigger')
            .removeClass('is-active')
            .filter('.is-' + activeView)
            .addClass('is-active');

        $('.products')
            .toggleClass('products--row', isRow)
            .toggleClass('products--grid', !isRow);

        $('.js-listing-item')
            .toggleClass('is-row', isRow)
            .toggleClass('is-grid', !isRow);

        if ($(document.activeElement).is('.js-filter-view-trigger')) {
            $(document.activeElement).blur();
        }

        Form.rebuildSpinners();
    });
});